import { render, staticRenderFns } from "./TimeslotCollectionMultiDragList.vue?vue&type=template&id=12f3cc50&"
import script from "./TimeslotCollectionMultiDragList.vue?vue&type=script&lang=js&"
export * from "./TimeslotCollectionMultiDragList.vue?vue&type=script&lang=js&"
import style0 from "./TimeslotCollectionMultiDragList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports